(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-service-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const closeDetails = (details) => {
      const body = details.querySelector('.tiny-service-faq__body');
      if (!body || !details.open || details.dataset.animating === 'true') return;

      details.dataset.animating = 'true';
      body.style.height = `${body.scrollHeight}px`;
      body.offsetHeight;
      body.style.height = '0px';

      const finish = () => {
        details.open = false;
        body.style.height = '0px';
        details.dataset.animating = 'false';
        body.removeEventListener('transitionend', finish);
      };

      body.addEventListener('transitionend', finish);
    };

    const openDetails = (details) => {
      const body = details.querySelector('.tiny-service-faq__body');
      if (!body || details.open || details.dataset.animating === 'true') return;

      details.dataset.animating = 'true';
      details.open = true;
      body.style.height = '0px';
      body.offsetHeight;
      body.style.height = `${body.scrollHeight}px`;

      const finish = () => {
        body.style.height = `${body.scrollHeight}px`;
        details.dataset.animating = 'false';
        body.removeEventListener('transitionend', finish);
      };

      body.addEventListener('transitionend', finish);
    };

    const initServiceFaq = (root = document) => {
      root.querySelectorAll('.tiny-service-faq__item').forEach((details) => {
        if (details.dataset.slideInitialized === 'true') return;

        const summary = details.querySelector('summary');
        const body = details.querySelector('.tiny-service-faq__body');
        if (!summary || !body) return;

        details.dataset.slideInitialized = 'true';
        body.style.height = details.open ? `${body.scrollHeight}px` : '0px';

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          if (details.dataset.animating === 'true') return;

          const isOpen = details.open;

          if (isOpen) {
            closeDetails(details);
          } else {
            const group = details.closest('.tiny-service-faq__items');
            group?.querySelectorAll('.tiny-service-faq__item[open]').forEach((openItem) => {
              if (openItem !== details) closeDetails(openItem);
            });

            openDetails(details);
          }
        });
      });
    };

    initServiceFaq();
    document.addEventListener('shopify:section:load', (event) => initServiceFaq(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const transitionDuration = 500;

    const formatMoney = (cents, currency, moneyFormat) => {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
      }).format(cents / 100);
    };

    const escapeHtml = (value) => {
      const element = document.createElement('div');
      element.textContent = value || '';
      return element.innerHTML;
    };

    const renderCartDrawer = (cart, settings) => {
      if (!cart.item_count) {
        return '<p class="tiny-cart-drawer__empty">No products in the cart.</p>';
      }

      const items = cart.items
        .map((item, index) => {
          const imageUrl = escapeHtml(item.image || '');
          const image = item.image
            ? `<img class="tiny-cart-drawer__image" src="${imageUrl}" alt="${escapeHtml(item.product_title)}" loading="lazy">`
            : '';
          const itemUrl = escapeHtml(item.url || settings.cartUrl);

          return `
            <article class="tiny-cart-drawer__item">
              <a class="tiny-cart-drawer__image-link" href="${itemUrl}">${image}</a>
              <div class="tiny-cart-drawer__item-info">
                <a class="tiny-cart-drawer__title" href="${itemUrl}">${escapeHtml(item.product_title)}</a>
                <p class="tiny-cart-drawer__meta">${item.quantity} × <strong>${formatMoney(item.final_price || item.price, cart.currency || settings.currency, settings.moneyFormat)}</strong></p>
              </div>
              <button class="tiny-cart-drawer__remove" type="button" aria-label="Remove ${escapeHtml(item.product_title)}" data-cart-remove="${index + 1}">
                <span aria-hidden="true"></span>
              </button>
            </article>
          `;
        })
        .join('');

      return `
        <div class="tiny-cart-drawer__items">${items}</div>
        <div class="tiny-cart-drawer__summary">
          <div class="tiny-cart-drawer__subtotal">
            <span>Subtotal:</span>
            <strong>${formatMoney(cart.total_price, cart.currency || settings.currency, settings.moneyFormat)}</strong>
          </div>
          <div class="tiny-cart-drawer__actions">
            <a class="tiny-cart-drawer__button tiny-cart-drawer__button--secondary" href="${settings.cartUrl}">View cart</a>
            <a class="tiny-cart-drawer__button tiny-cart-drawer__button--primary" href="${settings.checkoutUrl}">Checkout</a>
          </div>
        </div>
      `;
    };

    const updateCartCount = (count) => {
      document.querySelectorAll('.tiny-header__cart').forEach((cartLink) => {
        let countElement = cartLink.querySelector('.tiny-header__cart-count');

        if (count > 0 && !countElement) {
          countElement = document.createElement('span');
          countElement.className = 'tiny-header__cart-count';
          cartLink.prepend(countElement);
        }

        if (countElement) {
          countElement.textContent = count;
          countElement.hidden = count === 0;
        }
      });
    };

    const fetchCart = async (rootUrl) => {
      const response = await fetch(`${rootUrl}cart.js`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    };

    const changeCartLine = async (rootUrl, line) => {
      const response = await fetch(`${rootUrl}cart/change.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ line, quantity: 0 }),
      });

      if (!response.ok) throw new Error('Cart change failed');
      return response.json();
    };

    const closeMegaMenus = () => {
      document.querySelectorAll('.tiny-header--mega-open').forEach((header) => {
        header.classList.remove('tiny-header--mega-open');

        if (window.scrollY <= 8) {
          header.classList.remove('tiny-header--stuck');
        }
      });

      document.querySelectorAll('[data-mega-menu]').forEach((menu) => {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        menu.querySelectorAll('[data-mega-menu-panel]').forEach((panel) => panel.classList.remove('is-active'));
      });

      document.querySelectorAll('[data-mega-menu-trigger]').forEach((trigger) => {
        trigger.classList.remove('is-active');
        trigger.setAttribute('aria-expanded', 'false');
      });
    };

    const closeMobileMenus = (immediate = false) => {
      document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
        const toggles = document.querySelectorAll('[data-mobile-menu-toggle]');

        menu.classList.remove('is-panel-open');
        toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));

        const completeClose = () => {
          menu.classList.remove('is-open');
          menu.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('tiny-mobile-menu-open');
        };

        if (immediate) {
          completeClose();
        } else {
          window.setTimeout(completeClose, transitionDuration);
        }
      });
    };

    const initTinyHeaders = () => {
      document.querySelectorAll('.tiny-header').forEach((header) => {
        if (header.dataset.stickyReady === 'true') return;

        header.dataset.stickyReady = 'true';

        let ticking = false;
        const updateStickyState = () => {
          const megaMenuIsOpen = header.classList.contains('tiny-header--mega-open');
          const isStuck = header.classList.contains('tiny-header--stuck');
          const shouldStick = megaMenuIsOpen || (isStuck ? window.scrollY > 8 : window.scrollY > 20);

          header.classList.toggle('tiny-header--stuck', shouldStick);
          ticking = false;
        };

        const requestUpdate = () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(updateStickyState);
        };

        updateStickyState();
        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate);
      });
    };

    initTinyHeaders();
    document.addEventListener('shopify:section:load', initTinyHeaders);

    const initAccountMenus = () => {
      document.querySelectorAll('.tiny-header__account').forEach((accountMenu) => {
        if (accountMenu.dataset.accountReady === 'true') return;

        accountMenu.dataset.accountReady = 'true';

        const trigger = accountMenu.querySelector('.tiny-header__account-trigger');
        const accountPanel = accountMenu.querySelector('.tiny-header__account-menu');
        const mobileQuery = window.matchMedia('(max-width: 749px)');

        const setVisibilityClass = (element, isOpen) => {
          element.classList.toggle('is-open', isOpen);
          element.classList.toggle('is-closed', !isOpen);
        };

        const restartOpeningAnimation = (element) => {
          element.classList.remove('is-opening');
          void element.offsetWidth;
          element.classList.add('is-opening');
        };

        const setOpen = (isOpen) => {
          setVisibilityClass(accountMenu, isOpen);
          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

          if (isOpen) {
            restartOpeningAnimation(accountMenu);
          } else {
            accountMenu.classList.remove('is-opening');
          }
        };

        accountMenu.addEventListener('mouseenter', () => {
          if (!mobileQuery.matches) setOpen(true);
        });

        accountMenu.addEventListener('mouseleave', () => {
          if (!mobileQuery.matches) setOpen(false);
        });

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          setOpen(mobileQuery.matches ? !accountMenu.classList.contains('is-open') : true);
        });

        accountPanel.addEventListener('animationend', () => accountMenu.classList.remove('is-opening'));

        accountMenu.querySelectorAll('.tiny-header__account-item').forEach((accountItem) => {
          const itemTrigger = accountItem.querySelector('.tiny-header__account-item-trigger');
          const itemPanel = accountItem.querySelector('.tiny-header__account-submenu');

          const setItemOpen = (isOpen) => {
            setVisibilityClass(accountItem, isOpen);
            itemTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

            if (isOpen) {
              restartOpeningAnimation(accountItem);
            } else {
              accountItem.classList.remove('is-opening');
            }
          };

          accountItem.addEventListener('mouseenter', () => {
            if (!mobileQuery.matches) setItemOpen(true);
          });

          accountItem.addEventListener('mouseleave', () => {
            if (!mobileQuery.matches) setItemOpen(false);
          });

          itemTrigger.addEventListener('click', (event) => {
            event.preventDefault();
            setItemOpen(mobileQuery.matches ? !accountItem.classList.contains('is-open') : true);
          });

          itemPanel.addEventListener('animationend', () => accountItem.classList.remove('is-opening'));
        });

        accountMenu.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            setOpen(false);
            trigger.focus();
          }
        });

        mobileQuery.addEventListener('change', () => {
          setOpen(false);
          accountMenu.querySelectorAll('.tiny-header__account-item').forEach((accountItem) => {
            setVisibilityClass(accountItem, false);
            accountItem.querySelector('.tiny-header__account-item-trigger').setAttribute('aria-expanded', 'false');
          });
        });
      });
    };

    initAccountMenus();
    document.addEventListener('shopify:section:load', initAccountMenus);

    const initMegaMenus = () => {
      document.querySelectorAll('[data-mega-menu]').forEach((menu) => {
        if (menu.dataset.megaReady === 'true') return;

        menu.dataset.megaReady = 'true';

        const section = menu.closest('.shopify-section') || document;
        const header = section.querySelector('.tiny-header');
        const triggers = section.querySelectorAll('[data-mega-menu-trigger]');
        const panels = menu.querySelectorAll('[data-mega-menu-panel]');
        let closeTimer;

        const openMenu = (menuIndex) => {
          window.clearTimeout(closeTimer);

          header.classList.add('tiny-header--stuck', 'tiny-header--mega-open');
          menu.classList.add('is-open');
          menu.setAttribute('aria-hidden', 'false');

          panels.forEach((panel) => {
            panel.classList.toggle('is-active', panel.dataset.megaMenuPanel === menuIndex);
          });

          triggers.forEach((trigger) => {
            const isActive = trigger.dataset.megaMenuTrigger === menuIndex;
            trigger.classList.toggle('is-active', isActive);
            trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          });
        };

        const scheduleClose = () => {
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(closeMegaMenus, 160);
        };

        triggers.forEach((trigger) => {
          trigger.addEventListener('mouseenter', () => openMenu(trigger.dataset.megaMenuTrigger));
          trigger.addEventListener('focus', () => openMenu(trigger.dataset.megaMenuTrigger));
          trigger.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') closeMegaMenus();
          });
        });

        header.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));
        header.addEventListener('mouseleave', scheduleClose);
        menu.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));
        menu.addEventListener('mouseleave', scheduleClose);

        section.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!section.contains(document.activeElement)) closeMegaMenus();
          }, 0);
        });
      });
    };

    initMegaMenus();
    document.addEventListener('shopify:section:load', initMegaMenus);

    const initMobileMenus = () => {
      document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
        if (menu.dataset.mobileMenuReady === 'true') return;

        menu.dataset.mobileMenuReady = 'true';

        const panel = menu.querySelector('.tiny-mobile-menu__panel');
        const toggles = document.querySelectorAll('[data-mobile-menu-toggle]');
        const closeButtons = menu.querySelectorAll('[data-mobile-menu-close]');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let openTimer;

        if (!reduceMotion) {
          menu.querySelectorAll('details').forEach((details) => {
            const summary = details.querySelector(':scope > summary');
            const content = details.querySelector(
              ':scope > .tiny-mobile-menu__children, :scope > .tiny-mobile-menu__grandchildren'
            );

            if (!summary || !content) return;

            summary.addEventListener('click', (event) => {
              event.preventDefault();

              const isOpening = !details.open;
              if (isOpening) details.open = true;

              details.classList.add('is-animating');

              const animation = content.animate(
                isOpening
                  ? [
                      { height: '0px', opacity: 0 },
                      { height: `${content.scrollHeight}px`, opacity: 1 }
                    ]
                  : [
                      { height: `${content.getBoundingClientRect().height}px`, opacity: 1 },
                      { height: '0px', opacity: 0 }
                    ],
                { duration: 280, easing: 'ease' }
              );

              animation.addEventListener('finish', () => {
                if (!isOpening) details.open = false;
                details.classList.remove('is-animating');
              });
            });
          });
        }

        const openMenu = () => {
          closeMegaMenus();
          closeMobileMenus(true);

          document.querySelectorAll('[data-cart-drawer]').forEach((drawer) => {
            drawer.classList.remove('is-open', 'is-panel-open');
            drawer.setAttribute('aria-hidden', 'true');
          });
          document.querySelectorAll('[data-search-overlay]').forEach((overlay) => {
            overlay.classList.remove('is-open');
            overlay.setAttribute('aria-hidden', 'true');
          });
          document.body.classList.remove('tiny-cart-drawer-open', 'tiny-search-overlay-open');

          window.clearTimeout(openTimer);
          menu.classList.add('is-open');
          menu.setAttribute('aria-hidden', 'false');
          document.body.classList.add('tiny-mobile-menu-open');
          toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));

          window.requestAnimationFrame(() => {
            menu.classList.add('is-panel-open');
          });

          openTimer = window.setTimeout(() => {
            panel.focus();
          }, transitionDuration);
        };

        toggles.forEach((toggle) => {
          toggle.addEventListener('click', (event) => {
            event.preventDefault();
            openMenu();
          });
        });

        closeButtons.forEach((button) => button.addEventListener('click', () => closeMobileMenus()));

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && menu.classList.contains('is-open')) {
            closeMobileMenus();
          }
        });
      });
    };

    initMobileMenus();
    document.addEventListener('shopify:section:load', initMobileMenus);

    const initCartDrawers = () => {
      document.querySelectorAll('[data-cart-drawer]').forEach((drawer) => {
        if (drawer.dataset.drawerReady === 'true') return;

        drawer.dataset.drawerReady = 'true';

        const content = drawer.querySelector('[data-cart-drawer-content]');
        const panel = drawer.querySelector('.tiny-cart-drawer__panel');
        const toggles = document.querySelectorAll('[data-cart-drawer-toggle]');
        const closeButtons = drawer.querySelectorAll('[data-cart-drawer-close]');
        let openTimer;
        let closeTimer;
        const settings = {
          cartUrl: drawer.dataset.cartUrl || '/cart',
          checkoutUrl: drawer.dataset.checkoutUrl || '/checkout',
          rootUrl: drawer.dataset.rootUrl || '/',
          currency: drawer.dataset.currency || 'USD',
          moneyFormat: drawer.dataset.moneyFormat || '$' + '{amount}',
        };

        const refreshDrawer = async () => {
          const cart = await fetchCart(settings.rootUrl);
          content.innerHTML = renderCartDrawer(cart, settings);
          updateCartCount(cart.item_count);
        };

        const openDrawer = async () => {
          closeMegaMenus();
          closeMobileMenus(true);
          window.clearTimeout(openTimer);
          window.clearTimeout(closeTimer);

          drawer.classList.add('is-open');
          drawer.classList.remove('is-panel-open');
          drawer.setAttribute('aria-hidden', 'false');
          document.body.classList.add('tiny-cart-drawer-open');
          toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));

          openTimer = window.setTimeout(() => {
            drawer.classList.add('is-panel-open');
            panel.focus();
          }, transitionDuration);

          try {
            await refreshDrawer();
          } catch (error) {
            window.clearTimeout(openTimer);
            drawer.classList.remove('is-open', 'is-panel-open');
            document.body.classList.remove('tiny-cart-drawer-open');
            window.location.href = settings.cartUrl;
            return;
          }
        };

        const closeDrawer = () => {
          window.clearTimeout(openTimer);
          window.clearTimeout(closeTimer);

          drawer.classList.remove('is-panel-open');
          toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));

          closeTimer = window.setTimeout(() => {
            drawer.classList.remove('is-open');
            drawer.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('tiny-cart-drawer-open');
          }, transitionDuration);
        };

        drawer.addEventListener('tiny:cart-drawer:open', openDrawer);

        toggles.forEach((toggle) => {
          toggle.addEventListener('click', (event) => {
            event.preventDefault();
            openDrawer();
          });
        });

        closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

        drawer.addEventListener('click', async (event) => {
          const removeButton = event.target.closest('[data-cart-remove]');
          if (!removeButton) return;

          removeButton.disabled = true;

          try {
            const cart = await changeCartLine(settings.rootUrl, Number(removeButton.dataset.cartRemove));
            content.innerHTML = renderCartDrawer(cart, settings);
            updateCartCount(cart.item_count);
          } catch (error) {
            removeButton.disabled = false;
          }
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
            closeDrawer();
          }
        });
      });
    };

    initCartDrawers();
    document.addEventListener('shopify:section:load', initCartDrawers);

    const initSearchOverlays = () => {
      document.querySelectorAll('[data-search-overlay]').forEach((overlay) => {
        if (overlay.dataset.searchReady === 'true') return;

        overlay.dataset.searchReady = 'true';

        const input = overlay.querySelector('[data-search-overlay-input]');
        const toggles = document.querySelectorAll('[data-search-overlay-toggle]');
        const closeButtons = overlay.querySelectorAll('[data-search-overlay-close]');

        const openSearch = () => {
          closeMegaMenus();
          closeMobileMenus(true);
          document.querySelectorAll('[data-cart-drawer]').forEach((drawer) => {
            drawer.classList.remove('is-open', 'is-panel-open');
            drawer.setAttribute('aria-hidden', 'true');
          });
          document.body.classList.remove('tiny-cart-drawer-open');

          overlay.classList.add('is-open');
          overlay.setAttribute('aria-hidden', 'false');
          document.body.classList.add('tiny-search-overlay-open');
          toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));

          window.setTimeout(() => {
            input.focus();
          }, transitionDuration);
        };

        const closeSearch = () => {
          overlay.classList.remove('is-open');
          overlay.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('tiny-search-overlay-open');
          toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
        };

        toggles.forEach((toggle) => {
          toggle.addEventListener('click', (event) => {
            event.preventDefault();
            openSearch();
          });
        });

        closeButtons.forEach((button) => button.addEventListener('click', closeSearch));

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
            closeSearch();
          }
        });
      });
    };

    initSearchOverlays();
    document.addEventListener('shopify:section:load', initSearchOverlays);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const initTinyProduct = (section = document) => {
    section.querySelectorAll('[data-tiny-product]').forEach((productSection) => {
      const quantityControl = productSection.querySelector('[data-quantity-control]');
      if (quantityControl && quantityControl.dataset.initialized !== 'true') {
        quantityControl.dataset.initialized = 'true';

        const input = quantityControl.querySelector('[data-quantity-input]');
        const minus = quantityControl.querySelector('[data-quantity-minus]');
        const plus = quantityControl.querySelector('[data-quantity-plus]');

        const setValue = (nextValue) => {
          const min = Number(input.min || 1);
          const value = Math.max(min, Number(nextValue) || min);
          input.value = value;
        };

        minus.addEventListener('click', () => setValue(Number(input.value) - 1));
        plus.addEventListener('click', () => setValue(Number(input.value) + 1));
        input.addEventListener('change', () => setValue(input.value));
      }

      if (productSection.dataset.galleryInitialized !== 'true') {
        productSection.dataset.galleryInitialized = 'true';

        const featuredButton = productSection.querySelector('[data-lightbox-open]');
        const featuredImage = featuredButton ? featuredButton.querySelector('img') : null;
        const lightbox = productSection.querySelector('[data-product-lightbox]');
        const lightboxImage = lightbox ? lightbox.querySelector('[data-lightbox-image]') : null;
        const closeButtons = lightbox ? lightbox.querySelectorAll('[data-lightbox-close]') : [];

        productSection.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
          thumb.addEventListener('click', () => {
            if (!featuredButton || !featuredImage) return;

            featuredImage.src = thumb.dataset.imageUrl;
            featuredImage.removeAttribute('srcset');
            featuredImage.alt = thumb.dataset.imageAlt || '';
            featuredButton.dataset.lightboxSrc = thumb.dataset.imageFullUrl || thumb.dataset.imageUrl;
            featuredButton.dataset.lightboxAlt = thumb.dataset.imageAlt || '';

            productSection.querySelectorAll('[data-gallery-thumb]').forEach((otherThumb) => {
              otherThumb.classList.toggle('is-active', otherThumb === thumb);
            });
          });
        });

        const closeLightbox = () => {
          if (!lightbox) return;

          lightbox.hidden = true;
          lightbox.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('tiny-product-lightbox-open');
        };

        featuredButton?.addEventListener('click', () => {
          if (!lightbox || !lightboxImage) return;

          lightboxImage.src = featuredButton.dataset.lightboxSrc;
          lightboxImage.alt = featuredButton.dataset.lightboxAlt || '';
          lightbox.hidden = false;
          lightbox.setAttribute('aria-hidden', 'false');
          document.body.classList.add('tiny-product-lightbox-open');
        });

        closeButtons.forEach((button) => button.addEventListener('click', closeLightbox));

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && lightbox && !lightbox.hidden) {
            closeLightbox();
          }
        });
      }

      if (productSection.dataset.cartSubmitInitialized !== 'true') {
        productSection.dataset.cartSubmitInitialized = 'true';

        const productForm = productSection.querySelector('.tiny-product__form');
        const addButton = productSection.querySelector('[data-add-button]');
        const rootUrl = window.Shopify?.routes?.root || '/';

        productForm?.addEventListener('submit', async (event) => {
          event.preventDefault();

          if (!addButton || addButton.disabled) return;

          const defaultLabel = addButton.textContent.trim() || 'Add to cart';
          addButton.disabled = true;
          addButton.textContent = 'Adding...';

          try {
            const response = await fetch(`${rootUrl}cart/add.js`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: new FormData(productForm),
            });

            if (!response.ok) throw new Error('Add to cart failed');

            document.querySelector('[data-cart-drawer]')?.dispatchEvent(new CustomEvent('tiny:cart-drawer:open'));
          } catch (error) {
            addButton.textContent = 'Unable to add';
            window.setTimeout(() => {
              addButton.textContent = defaultLabel;
            }, 1800);
          } finally {
            addButton.disabled = false;
            if (addButton.textContent === 'Adding...') {
              addButton.textContent = defaultLabel;
            }
          }
        });
      }

      if (productSection.dataset.variantInitialized !== 'true') {
        productSection.dataset.variantInitialized = 'true';

        const variantScript = productSection.querySelector('[data-product-variants]');
        const optionControls = productSection.querySelectorAll('[data-option-control]');
        const variantInput = productSection.querySelector('[data-variant-id]');
        const addButton = productSection.querySelector('[data-add-button]');
        const priceElement = productSection.querySelector('[data-product-price]');

        if (!variantScript || !optionControls.length || !variantInput || !addButton) return;

        const variants = JSON.parse(variantScript.textContent);
        const currency = productSection.dataset.currency || 'USD';
        const formatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
          currencyDisplay: 'code',
        });

        const formatMoney = (value) => formatter.format((Number(value) || 0) / 100);

        const getSelectedOptions = () => {
          const selected = [];

          optionControls.forEach((control) => {
            const position = Number(control.dataset.optionPosition) - 1;

            if (control.type === 'radio' && !control.checked) return;

            selected[position] = control.value;
          });

          return selected;
        };

        const updateSelectedLabels = (selectedOptions) => {
          productSection.querySelectorAll('[data-option-selected]').forEach((label) => {
            const position = Number(label.dataset.optionSelected) - 1;
            label.textContent = selectedOptions[position] || '';
          });
        };

        const syncVariant = () => {
          const selectedOptions = getSelectedOptions();
          const selectedVariant = variants.find((variant) => (
            variant.options.every((option, index) => option === selectedOptions[index])
          ));

          updateSelectedLabels(selectedOptions);

          if (!selectedVariant) {
            addButton.disabled = true;
            addButton.textContent = 'Unavailable';
            return;
          }

          variantInput.value = selectedVariant.id;
          addButton.disabled = !selectedVariant.available;
          addButton.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';

          if (priceElement && !priceElement.hasAttribute('data-price-range')) {
            priceElement.textContent = selectedVariant.price_formatted || formatMoney(selectedVariant.price);
          }
        };

        optionControls.forEach((control) => control.addEventListener('change', syncVariant));
        syncVariant();
      }
    });
  };

  initTinyProduct();
  document.addEventListener('shopify:section:load', (event) => initTinyProduct(event.target));

  } catch(e) { console.error(e); }
})();
})();
